export default "__VITE_ASSET__a81d0b21__"